import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {CommentDto} from "@/store/forum/types";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import PlayerStore from "@/store/player";
import {IntegrationUtils} from "@/utils/integration-utils";

export class CommentPanel extends Phaser.GameObjects.Container {

    private myVote!: number;
    private rate!: number;

    constructor(scene: Phaser.Scene, t: CommentDto, rateCallback: (rate: number) => unknown, settVisible: boolean,
                settingCallback: () => unknown, profileCallback: () => unknown, replyCallback: (answerTo?:string) => unknown) {
        super(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;
        this.rate = t.rate;
        this.myVote = t.myVote;

        let self = this;

        let authorText = TextUtils.addTextAdvanced(scene, t.playerName, 70, 10,
            '#ffd565', 13, 'normal', 500, 'left', 1, Fonts.MYRIADPRO_REGULAR);
        authorText.setOrigin(0, 0);

        authorText.setInteractive().on('pointerup', () => {
            profileCallback();
        });

        let replyIcon = SpriteUtils.addImage(this.scene!, authorText.x/CU.S + authorText.width/CU.S + 15, authorText.y/CU.S-2, Keys.FRM_REPLY_ARROW)
            .setOrigin(0.5, 0.0);
        replyIcon.setInteractive().on('pointerup', () => {
            replyCallback(t.playerName);
        });

        let idText = TextUtils.addTextAdvanced(scene, "Id " + t.playerId , replyIcon.x/CU.S + replyIcon.width/2/CU.S + 5, 10,
            '#ffd565', 13, 'normal', 500, 'left', 1, Fonts.MYRIADPRO_REGULAR);
        idText.setOrigin(0, 0);
        idText.alpha = 0.3;
        idText.setVisible(PlayerStore.hasModerAccess())

        let copyIdIcon = SpriteUtils.addImage(this.scene!, idText.x/CU.S + idText.width/CU.S + 15, 10,  Keys.ATLAS_PROFILE, Keys.UI_ARROW_RIGHT)
            .setOrigin(0.5, 0.0);
        copyIdIcon.setInteractive().on('pointerup', () => {
            IntegrationUtils.copyToClipboard(String(t.playerId));
            new FeedbackPanel(self.scene, 'ID ' + String(t.playerId) + ' ' + Tr('copied.large'), undefined, true).show();
        });
        copyIdIcon.setScale(0.7);
        copyIdIcon.alpha = 0.3;
        copyIdIcon.setVisible(PlayerStore.hasModerAccess())

        let isCut = t.text.length > 1000;
        let txt = !isCut ? t.text : (t.text.substr(0, 750) + '.....');

        let mainText = TextUtils.addTextAdvanced(scene, txt, 70, 40,
            t.admin? '#d6b1ff' : '#eaeaea', 12, 'normal', 500, 'left', 1, Fonts.MYRIADPRO_REGULAR);
        mainText.setOrigin(0, 0);

        let tmTxt = Tr('crtd') + t.createdAt;
        if (t.editedAt && t.editorName ) {
            tmTxt += (Tr('edtd') + t.editorName + ' ' + t.editedAt);
        }
        let timesText = TextUtils.addTextAdvanced(scene, tmTxt, 70, mainText.getBottomCenter().y! / CU.S + 12,
            '#a1a1a1', 12, 'normal', 500, 'left', 1, Fonts.MYRIADPRO_REGULAR);
        timesText.setOrigin(0, 0);

        this.height = 100 + mainText.getBottomCenter().y! / CU.S - mainText.getTopCenter().y! / CU.S;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height*CU.S);

        let rateText = TextUtils.addTextAdvanced(scene, String(t.rate), 35, 56,
            '#eaeaea', 18, 'normal', 500, 'left', 1, Fonts.MYRIADPRO_REGULAR);
        rateText.setOrigin(0.5, 0.5);

        let upIcon = SpriteUtils.addImage(this.scene!, 35, 12, t.myVote > 0 ? Keys.FRM_UP_GREEN : Keys.FRM_UP)
            .setOrigin(0.5, 0.0);

        let downIcon = SpriteUtils.addImage(this.scene!, 35, 97, t.myVote < 0 ? Keys.FRM_UP_GREEN : Keys.FRM_UP, undefined, 1.0, -1.0)
            .setOrigin(0.5, 0.0);

        upIcon!.setInteractive().on('pointerdown', () => {
            if (self.myVote > 0) {
                self.rate = self.rate - 1;
            } else if (self.myVote < 0) {
                self.rate = self.rate + 2;
            } else {
                self.rate = self.rate + 1;
            }
            self.myVote = self.myVote > 0 ? 0 : 1;
            rateCallback(self.myVote);
            SpriteUtils.setSprite(scene, upIcon, self.myVote > 0 ? Keys.FRM_UP_GREEN : Keys.FRM_UP);
            SpriteUtils.setSprite(scene, downIcon, self.myVote < 0 ? Keys.FRM_UP_GREEN : Keys.FRM_UP);
            rateText.setText(String(self.rate));
        });

        downIcon!.setInteractive().on('pointerdown', () => {
            if (self.myVote < 0) {
                self.rate = self.rate + 1;
            } else if (self.myVote > 0) {
                self.rate = self.rate - 2;
            } else {
                self.rate = self.rate - 1;
            }
            self.myVote = self.myVote < 0 ? 0 : -1;
            rateCallback(self.myVote);
            SpriteUtils.setSprite(scene, upIcon, self.myVote > 0 ? Keys.FRM_UP_GREEN : Keys.FRM_UP);
            SpriteUtils.setSprite(scene, downIcon, self.myVote < 0 ? Keys.FRM_UP_GREEN : Keys.FRM_UP);
            rateText.setText(String(self.rate));
        });

        const separator = SpriteUtils.addSprite(this.scene!, 300, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5).setOrigin(0.5, 1);

        this.add([back, authorText, mainText, timesText, rateText, downIcon, upIcon, separator, replyIcon, idText, copyIdIcon]);

        if (settVisible) {
            let settButton = SpriteUtils.addImage(this.scene!, 555, 30, Keys.FRM_RADIO_OUT, undefined, 0.9).setOrigin(0.5, 0.5).setAlpha(0.9);
            let settText = this.scene!.add.text(555 * CU.S, 28 * CU.S, '...').setOrigin(0.5, 0.5);

            settButton.setInteractive().on('pointerdown', () => {
                settingCallback();
            });
            this.add([settButton, settText]);
        }

        let copyIcon = SpriteUtils.addImage(this.scene!, 555, 30 + (settVisible? 50 : 0) , Keys.FRM_COPY_ROUND, undefined, 0.9).setOrigin(0.5, 0.5).setAlpha(0.9);
        copyIcon.setInteractive().on('pointerup', () => {
            new FeedbackPanel(self.scene, Tr('message.copied'), undefined, true).show();
            let text = TextUtils.removeBracketsAndCurlyBraces(t.text);
            IntegrationUtils.copyToClipboard(text);
        });
        copyIcon.setVisible(IntegrationUtils.isClipboardAPIEnabled());
        this.add([copyIcon]);
    }

}
